import { preloadable as lazy } from "./lazyWithRetry";

// =======> GENERIC <=======
export const MaintainanceModeFallback = lazy(
  () => import("../components/common/MaintainanceModeFallback"),
);
export const Announcement = lazy(
  () => import("../pages/(home)/(common)/announcements"),
);

// =======> AUTH <=======
export const Login = lazy(() => import("../pages/(auth)/Login"));
export const Impersonate = lazy(() => import("../pages/(auth)/Impersonate"));
export const SignInMFAVerification = lazy(
  () => import("../pages/(auth)/SignInMFAVerification"),
);
export const SignUp = lazy(() => import("../pages/(auth)/SignUp"));
export const VerifyOtp = lazy(() => import("../pages/(auth)/VerifyOtp"));
export const SignupOTPVerification = lazy(
  () => import("../pages/(auth)/SignupOTPVerification"),
);
export const ResetPassword = lazy(
  () => import("../pages/(auth)/ResetPassword"),
);
export const ForgotPassword = lazy(
  () => import("../pages/(auth)/ForgotPassword"),
);
export const CreatePassword = lazy(
  () => import("../pages/(auth)/CreatePassword"),
);

// =======> HOME <=======
export const QRUploadPage = lazy(() => import("../pages/QRUploadPage"));

// ****** My Space ******
export const Home = lazy(() => import("../pages/(home)/(my-space)/dashboard"));
export const CreateCompany = lazy(() => import("../pages/CreateCompany"));
export const CreatingCompany = lazy(() => import("../pages/CreatingCompany"));
export const MsTimeAttendanceLayout = lazy(() =>
  import("../pages/(home)/(my-space)/time-attendance").then((m) => ({
    default: m.MsTimeAttendanceLayout,
  })),
);
export const MsAttendanceSummaryPage = lazy(
  () =>
    import("../pages/(home)/(my-space)/time-attendance/_components/MyAttendanceSummary"),
);
export const MsRegularizationList = lazy(() =>
  import("../pages/(home)/(my-space)/time-attendance/_components/regularization").then(
    (m) => ({ default: m.Regularization }),
  ),
);
export const MsOvertimePage = lazy(() =>
  import("../pages/(home)/(my-space)/time-attendance/_components/Overtime").then(
    (m) => ({ default: m.Overtime }),
  ),
);
export const MsAttendanceExceptionsList = lazy(() =>
  import("../pages/(home)/(my-space)/time-attendance/_components/attendance-exceptions").then(
    (m) => ({ default: m.AttendanceExceptions }),
  ),
);
export const UpsertRegularization = lazy(
  () =>
    import("../pages/(home)/(my-space)/time-attendance/_components/regularization/upsert-regularization"),
);
export const ViewRegularization = lazy(
  () =>
    import("../pages/(home)/(my-space)/time-attendance/_components/regularization/view-regularization"),
);
export const MsAttendanceExceptionView = lazy(() =>
  import("../pages/(home)/(my-space)/time-attendance/_components/attendance-exceptions/attendance-exceptions-view").then(
    (m) => ({ default: m.AttendanceExceptionsView }),
  ),
);
export const MsApplyOvertimePage = lazy(
  () =>
    import("../pages/(home)/(my-space)/time-attendance/apply-overtime"),
);
export const MsOvertimeDetailPage = lazy(
  () =>
    import("../pages/(home)/(my-space)/time-attendance/overtime-detail"),
);

export const Settings = lazy(
  () => import("../pages/(home)/(my-space)/settings"),
);
export const MsSettingsProfilePage = lazy(() =>
  import("../pages/(home)/(my-space)/settings/profile-settings").then(
    (m) => ({ default: m.ProfileSettings }),
  ),
);
export const MsSettingsSecurityPage = lazy(() =>
  import("../pages/(home)/(my-space)/settings/security-settings").then(
    (m) => ({ default: m.SecuritySettings }),
  ),
);
export const MsSettingsNotificationsPage = lazy(() =>
  import("../pages/(home)/(my-space)/settings/notification-settings").then(
    (m) => ({ default: m.NotificationSettings }),
  ),
);

// ****** Assets ******
export const AssetRequestForm = lazy(
  () => import("../pages/(home)/(my-space)/assets/AssetRequestForm"),
);
export const Assets = lazy(() => import("../pages/(home)/(my-space)/assets"));
export const MsAssignedAssetsPage = lazy(
  () => import("../pages/(home)/(my-space)/assets/assigned-assets"),
);
export const MsRequestedAssetsPage = lazy(
  () => import("../pages/(home)/(my-space)/assets/requested-assets"),
);
export const LeaveManagement = lazy(
  () => import("../pages/(home)/(my-space)/leave-management"),
);
export const MsLeaveManagementLayout = lazy(() =>
  import("../pages/(home)/(my-space)/leave-management").then((m) => ({
    default: m.MsLeaveManagementLayout,
  })),
);
export const NewLeaveRequest = lazy(
  () => import("../pages/(home)/(my-space)/leave-management/apply-leave"),
);

// ****** Documents ******
export const Documents = lazy(
  () => import("../pages/(home)/(my-space)/documents"),
);
export const MsMyDocumentsPage = lazy(
  () => import("../pages/(home)/(my-space)/documents/my-documents"),
);
export const MsSentRequestsPage = lazy(
  () => import("../pages/(home)/(my-space)/documents/sent-requests"),
);
export const MsReceivedRequestsPage = lazy(
  () => import("../pages/(home)/(my-space)/documents/recieved-requests"),
);
export const MsSignedDocumentsPage = lazy(
  () => import("../pages/(home)/(my-space)/documents/signed-documents"),
);
export const DocumentRequestForm = lazy(
  () =>
    import("../pages/(home)/(my-space)/documents/_components/document-request-form"),
);
export const DocumentUploadForm = lazy(
  () =>
    import("../pages/(home)/(my-space)/documents/_components/document-upload-form"),
);
export const MySpaceDocumentRequestView = lazy(
  () =>
    import("../pages/(home)/(my-space)/documents/_components/document-request-view"),
);

// ****** Company ******
export const CompanyDashboard = lazy(
  () => import("../pages/(home)/(company)/dashboard"),
);
export const CompanyLeaveManagementLayout = lazy(() =>
  import("../pages/(home)/(company)/leave-management").then((m) => ({
    default: m.CompanyLeaveManagementLayout,
  })),
);
export const CompanyAllLeavesPage = lazy(
  () => import("../pages/(home)/(company)/leave-management/all-leaves"),
);
export const CompanyLeaveSummary = lazy(
  () => import("../pages/(home)/(company)/leave-management/leave-summary"),
);
export const CompanyWorkflowRequestsPage = lazy(
  () => import("../pages/(home)/(company)/leave-management/workflow-request"),
);
export const CompanyTimeAttendanceLayout = lazy(() =>
  import("../pages/(home)/(company)/time-attendance").then((m) => ({
    default: m.CompanyTimeAttendanceLayout,
  })),
);
export const CompanyEmployeeDrillDownLayout = lazy(() =>
  import("../pages/(home)/(company)/time-attendance").then((m) => ({
    default: m.CompanyEmployeeDrillDownLayout,
  })),
);
export const CompanyTimeAttendanceList = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/time-attendance").then(
    (m) => ({ default: m.TimeAttendance }),
  ),
);
export const CompanyRegularizeRequestsList = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/regularize-requests").then(
    (m) => ({ default: m.RegularizeRequests }),
  ),
);
export const CompanyAttendanceExceptionsList = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/attendance-exceptions").then(
    (m) => ({ default: m.AttendanceExceptions }),
  ),
);
export const CompanyEmployeeAttendanceSummary = lazy(
  () =>
    import("../pages/(home)/(company)/time-attendance/_components/time-attendance/components/EmployeeAttendanceSummary"),
);
export const CompanyEmployeeOvertimeSummary = lazy(
  () =>
    import("../pages/(home)/(company)/time-attendance/_components/overtime/EmployeeOvertimeSummary"),
);
export const CompanyEmployees = lazy(
  () => import("../pages/(home)/(company)/employees"),
);
export const CompanyEmployeesDraftPage = lazy(
  () => import("../pages/(home)/(company)/employees/draft"),
);
export const CompanyEmployeesInstantPage = lazy(
  () => import("../pages/(home)/(company)/employees/instant"),
);
export const CompanyEmployeesActivePage = lazy(
  () => import("../pages/(home)/(company)/employees/active"),
);
export const CompanyEmployeesAllPage = lazy(
  () => import("../pages/(home)/(company)/employees/all-employees"),
);
export const CompanyEmployeesOffboardedPage = lazy(
  () => import("../pages/(home)/(company)/employees/offboarded"),
);
export const CompanyOnboarding = lazy(
  () => import("../pages/(home)/(company)/onboarding"),
);

// Company setup ("go-live") guide — the COMPANY onboarding journey, distinct
// from the employee onboarding module directly above.
export const CompanySetupGuide = lazy(
  () => import("../pages/(home)/(company)/company-setup"),
);
export const CompanyOnboardingStart = lazy(
  () => import("../pages/(home)/(company)/onboarding/start"),
);
export const CompanyOnboardingEmployee = lazy(
  () => import("../pages/(home)/(company)/onboarding/employee"),
);
export const CompanyRecruitment = lazy(
  () => import("../pages/(home)/(company)/recruitment"),
);
// Each recruitment tab is its own route, so each is code-split on its own —
// opening Job Openings no longer pulls in the interview board or talent pool.
export const CompanyRecruitmentDashboardTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/dashboard").then((m) => ({
    default: m.RecruitmentDashboardTab,
  })),
);
export const CompanyRecruitmentJobsTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/jobs").then((m) => ({
    default: m.RecruitmentJobsTab,
  })),
);
export const CompanyRecruitmentCandidatesTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/candidates").then((m) => ({
    default: m.RecruitmentCandidatesTab,
  })),
);
export const CompanyRecruitmentInterviewsTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/interviews").then((m) => ({
    default: m.RecruitmentInterviewsTab,
  })),
);
export const CompanyRecruitmentAssessmentsTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/assessments").then((m) => ({
    default: m.RecruitmentAssessmentsTab,
  })),
);
export const CompanyRecruitmentOffersTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/offers").then((m) => ({
    default: m.RecruitmentOffersTab,
  })),
);
export const CompanyRecruitmentTalentPoolTab = lazy(() =>
  import("../pages/(home)/(company)/recruitment/talent-pool").then((m) => ({
    default: m.RecruitmentTalentPoolTab,
  })),
);
export const CompanyRecruitmentJobForm = lazy(
  () => import("../pages/(home)/(company)/recruitment/job-form"),
);
export const CompanyRecruitmentAiJob = lazy(
  () => import("../pages/(home)/(company)/recruitment/ai-job"),
);
export const CompanyRecruitmentCreateJob = lazy(
  () => import("../pages/(home)/(company)/recruitment/create-job"),
);
export const CompanyRecruitmentAssessmentNew = lazy(
  () => import("../pages/(home)/(company)/recruitment/assessment-new"),
);
export const CompanyRecruitmentPipeline = lazy(
  () => import("../pages/(home)/(company)/recruitment/pipeline"),
);
export const CompanyRecruitmentAnalysis = lazy(
  () => import("../pages/(home)/(company)/recruitment/analysis"),
);
export const CompanyRecruitmentCompare = lazy(
  () => import("../pages/(home)/(company)/recruitment/compare"),
);
export const CompanyRecruitmentCandidateProfile = lazy(
  () => import("../pages/(home)/(company)/recruitment/candidate"),
);
export const CompanyRecruitmentAiScorecard = lazy(
  () => import("../pages/(home)/(company)/recruitment/ai-scorecard"),
);
export const CompanyRecruitmentAssessmentForm = lazy(
  () => import("../pages/(home)/(company)/recruitment/assessment-form"),
);
export const CompanyRecruitmentOfferDetail = lazy(
  () => import("../pages/(home)/(company)/recruitment/offer"),
);
export const CompanyRecruitmentOfferForm = lazy(
  () => import("../pages/(home)/(company)/recruitment/offer-form"),
);
export const CompanyRecruitmentScheduleInterview = lazy(
  () => import("../pages/(home)/(company)/recruitment/schedule-interview"),
);
export const CompanyRecruitmentSettingsPage = lazy(
  () => import("../pages/(home)/(company)/recruitment/settings"),
);
export const CompanyRecruitmentActivity = lazy(
  () => import("../pages/(home)/(company)/recruitment/activity"),
);
export const MySpaceRecruitment = lazy(
  () => import("../pages/(home)/(my-space)/recruitment"),
);
export const CompanyUpsertEmployees = lazy(
  () => import("../pages/(home)/(company)/employees/upsert-employee"),
);
export const CompanyCreateEmployee = lazy(
  () => import("../pages/(home)/(company)/employees/upsert-employee/create"),
);
export const CompanyInstantOnboarding = lazy(
  () => import("../pages/(home)/(company)/employees/instant-onboarding"),
);
export const CompanyViewEmployee = lazy(
  () => import("../pages/(home)/(company)/employees/view-employee"),
);
export const CompanyUpsertRegularization = lazy(
  () =>
    import("../pages/(home)/(company)/time-attendance/_components/regularize-requests/upsert-regularization"),
);
export const CompanyViewRegularization = lazy(
  () =>
    import("../pages/(home)/(company)/time-attendance/_components/regularize-requests/view-regularization"),
);
export const CompanyAttendanceExceptionView = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/attendance-exceptions/attendance-exceptions-view").then(
    (m) => ({ default: m.AttendanceExceptionsView }),
  ),
);
export const CompanyOvertimeList = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/overtime/CompanyOvertimeList").then(
    (m) => ({ default: m.CompanyOvertimeList }),
  ),
);
export const CompanyOvertimeDetail = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/overtime/CompanyOvertimeDetail").then(
    (m) => ({ default: m.CompanyOvertimeDetail }),
  ),
);
export const CompanyApplyOvertime = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/_components/overtime/CompanyApplyOvertime").then(
    (m) => ({ default: m.CompanyApplyOvertime }),
  ),
);
export const CompanyDocuments = lazy(
  () => import("../pages/(home)/(company)/documents"),
);
export const CompanyEmployeeDocsPage = lazy(
  () => import("../pages/(home)/(company)/documents/employee-documents"),
);
export const CompanyDocsPage = lazy(
  () => import("../pages/(home)/(company)/documents/company-documents"),
);
export const CompanySentRequestsPage = lazy(
  () => import("../pages/(home)/(company)/documents/sent-requests"),
);
export const CompanyReceivedRequestsPage = lazy(
  () => import("../pages/(home)/(company)/documents/recieved-requests"),
);
export const CompanyFiles = lazy(
  () => import("../pages/(home)/(company)/files"),
);
export const CompanyFilesAllPage = lazy(
  () => import("../pages/(home)/(company)/files/all"),
);
export const CompanyFilesImagesPage = lazy(
  () => import("../pages/(home)/(company)/files/images"),
);
export const CompanyFilesDocumentsPage = lazy(
  () => import("../pages/(home)/(company)/files/documents"),
);
export const CompanyFilesOtherPage = lazy(
  () => import("../pages/(home)/(company)/files/other"),
);
export const CompanyFileDetails = lazy(
  () => import("../pages/(home)/(company)/files/file-details"),
);
export const CompanyEmployeeDocumentsDetails = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/employee-documents-details"),
);
export const CompanyDocumentUploadForm = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/document-upload-form"),
);
export const CompanyDocumentForm = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/company-documents/CompanyDocumentForm"),
);
export const CompanyDocumentRequestForm = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/document-request-form"),
);
export const CompanyDocumentRequestView = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/document-request-view"),
);
export const CompanyDocumentDetail = lazy(
  () =>
    import("../pages/(home)/(company)/documents/_components/document-detail"),
);
export const CompanyApplyLeave = lazy(
  () => import("../pages/(home)/(company)/leave-management/apply-leave"),
);
export const CompanySettings = lazy(
  () => import("../pages/(home)/(company)/settings"),
);
export const CompanySettingsOrganizationPage = lazy(() =>
  import("../pages/(home)/(company)/settings/organization-settings").then(
    (m) => ({ default: m.OrganizationSettings }),
  ),
);
export const CompanySettingsRolesPage = lazy(() =>
  import("../pages/(home)/(company)/settings/roles-and-permissions").then(
    (m) => ({ default: m.RolesAndPermissions }),
  ),
);
// ── Module settings pages (moved out of Company Settings) ───────────────────
export const CompanyTimeAttendanceSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/time-attendance/settings").then((m) => ({
    default: m.CompanyTimeAttendanceSettings,
  })),
);
export const CompanyPayrollSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/payrolls/settings").then((m) => ({
    default: m.CompanyPayrollSettings,
  })),
);
export const CompanyAssetSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/assets/settings").then((m) => ({
    default: m.CompanyAssetSettings,
  })),
);
export const CompanyExpenseSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/expenses/settings").then((m) => ({
    default: m.CompanyExpenseSettings,
  })),
);
export const CompanySalesCommissionsSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/sales-commissions/settings").then((m) => ({
    default: m.CompanySalesCommissionsSettings,
  })),
);
export const CompanyDocumentSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/documents/settings").then((m) => ({
    default: m.CompanyDocumentSettings,
  })),
);
export const CompanyLeaveSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/leave-management/settings").then((m) => ({
    default: m.CompanyLeaveSettings,
  })),
);
export const CompanyOnboardingSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/onboarding/settings").then((m) => ({
    default: m.CompanyOnboardingSettings,
  })),
);
export const CompanySettingsCompanyPoliciesPage = lazy(() =>
  import("../pages/(home)/(company)/settings/company-policies-settings").then(
    (m) => ({ default: m.CompanyPoliciesSettings }),
  ),
);
export const CompanySettingsTemplatesPage = lazy(() =>
  import("../pages/(home)/(company)/settings/templates").then((m) => ({
    default: m.TemplatesSettings,
  })),
);
export const CompanySettingsCalendarsPage = lazy(() =>
  import("../pages/(home)/(company)/settings/calendars").then((m) => ({
    default: m.CalendarSettings,
  })),
);
export const DocumentTemplateBuilder = lazy(
  () => import("../pages/(home)/(company)/settings/templates/builder"),
);
export const DocumentTemplateSigning = lazy(
  () => import("../pages/(home)/(company)/settings/templates/sign"),
);
export const CompanyInventoryListing = lazy(
  () => import("../pages/(home)/(company)/assets"),
);
export const CompanyRegularAssetsPage = lazy(
  () => import("../pages/(home)/(company)/assets/regular-assets"),
);
export const CompanyConsumableAssetsPage = lazy(
  () => import("../pages/(home)/(company)/assets/consumable-assets"),
);
export const CompanyAssetRequestsPage = lazy(
  () => import("../pages/(home)/(company)/assets/asset-requests"),
);
export const CompanyAssetsWorkflowRequestsPage = lazy(
  () => import("../pages/(home)/(company)/assets/workflow-requests"),
);
export const CompanyAssetsListing = lazy(
  () => import("../pages/(home)/(company)/assets/asset-type"),
);
export const CompanyAssetCreation = lazy(
  () => import("../pages/(home)/(company)/assets/create"),
);
export const CompanyAssetDetail = lazy(
  () => import("../pages/(home)/(company)/assets/asset-detail"),
);
export const CompanyConsumableAssetCreation = lazy(
  () => import("../pages/(home)/(company)/assets/create/consumable"),
);
export const CompanyAssetRequestDetails = lazy(
  () => import("../pages/(home)/(company)/assets/asset-request"),
);
export const CompanyWorkflowRequestDetail = lazy(
  () => import("../pages/(home)/(company)/assets/workflow-request/detail"),
);
export const CompanyLeaveWorkflowRequestDetail = lazy(
  () =>
    import("../pages/(home)/(company)/leave-management/workflow-request/detail"),
);

export const CompanyDigitalIdLayout = lazy(
  () => import("../pages/(home)/(company)/digital-id"),
);
export const CompanyDigitalIdEmployeesPage = lazy(
  () => import("../pages/(home)/(company)/digital-id/employees"),
);
export const CompanyDigitalIdSettingsPage = lazy(
  () => import("../pages/(home)/(company)/digital-id/settings"),
);

export const CompanyWorkflows = lazy(
  () => import("../pages/(home)/(company)/workflows"),
);

export const StudioHub = lazy(
  () => import("../pages/(home)/(company)/studio"),
);
export const StudioWorkflowsList = lazy(
  () => import("../pages/(home)/(company)/studio/workflows"),
);
export const StudioWorkflowCategoryPicker = lazy(
  () => import("../pages/(home)/(company)/studio/workflows/category-picker"),
);
export const StudioWorkflowDescribe = lazy(
  () => import("../pages/(home)/(company)/studio/workflows/describe"),
);
export const StudioWorkflowSetup = lazy(
  () => import("../pages/(home)/(company)/studio/workflows/setup"),
);
export const StudioWorkflowBuilder = lazy(
  () => import("../pages/(home)/(company)/studio/workflows/builder"),
);
export const StudioWorkflowBasePicker = lazy(
  () => import("../pages/(home)/(company)/studio/workflows/templates"),
);
export const StudioWorkflowTemplateGallery = lazy(
  () =>
    import("../pages/(home)/(company)/studio/workflows/template-gallery"),
);
export const StudioDocumentDescribe = lazy(
  () => import("../pages/(home)/(company)/studio/documents/describe"),
);
export const StudioDocumentsList = lazy(
  () => import("../pages/(home)/(company)/studio/documents/list"),
);
export const StudioDocumentTemplateGallery = lazy(
  () => import("../pages/(home)/(company)/studio/documents/template-gallery"),
);
export const StudioDocumentExisting = lazy(
  () => import("../pages/(home)/(company)/studio/documents/existing"),
);
export const StudioEmailTemplateDescribe = lazy(
  () => import("../pages/(home)/(company)/studio/email-templates/describe"),
);
export const StudioEmailTemplatesList = lazy(
  () => import("../pages/(home)/(company)/studio/email-templates/list"),
);
export const StudioEmailTemplateGallery = lazy(
  () =>
    import("../pages/(home)/(company)/studio/email-templates/template-gallery"),
);
export const StudioEmailTemplateExisting = lazy(
  () => import("../pages/(home)/(company)/studio/email-templates/existing"),
);
export const StudioEmailTemplateBuilder = lazy(
  () => import("../pages/(home)/(company)/studio/email-templates/builder"),
);

// ─── My App ─────────────────────────────────────────────────────────────────
export const CompanyMyAppLayout = lazy(() =>
  import("../pages/(home)/(company)/my-app/layout").then((m) => ({
    default: m.CompanyMyAppLayout,
  })),
);
export const MyAppLibrary = lazy(
  () => import("../pages/(home)/(company)/my-app"),
);
export const MyAppCreate = lazy(
  () => import("../pages/(home)/(company)/my-app/create"),
);
export const MyAppView = lazy(
  () => import("../pages/(home)/(company)/my-app/view"),
);
export const MyAppAppStore = lazy(
  () => import("../pages/(home)/(company)/my-app/app-store"),
);
// ─── My App (My Space) ──────────────────────────────────────────────────────
export const MyAppMySpaceLayout = lazy(() =>
  import("../pages/(home)/(my-space)/my-app/layout").then((m) => ({
    default: m.MyAppMySpaceLayout,
  })),
);
export const MyAppMySpaceLibrary = lazy(
  () => import("../pages/(home)/(my-space)/my-app"),
);
export const MyAppMySpaceCreate = lazy(
  () => import("../pages/(home)/(my-space)/my-app/create"),
);
export const MyAppMySpaceView = lazy(
  () => import("../pages/(home)/(my-space)/my-app/view"),
);
export const MyAppMySpaceAppStore = lazy(
  () => import("../pages/(home)/(my-space)/my-app/app-store"),
);
export const CompanyWorkflowsLeaveManagementPage = lazy(
  () => import("../pages/(home)/(company)/workflows/leave-management"),
);
export const CompanyWorkflowsAssetManagementPage = lazy(
  () => import("../pages/(home)/(company)/workflows/asset-management"),
);
export const CompanyWorkflowsOvertimeRequestsPage = lazy(
  () => import("../pages/(home)/(company)/workflows/overtime-requests"),
);
export const StudioFormDescribe = lazy(
  () => import("../pages/(home)/(company)/studio/forms/describe"),
);
export const StudioFormsList = lazy(
  () => import("../pages/(home)/(company)/studio/forms/list"),
);
export const StudioFormTemplateGallery = lazy(
  () => import("../pages/(home)/(company)/studio/forms/template-gallery"),
);
export const StudioFormExisting = lazy(
  () => import("../pages/(home)/(company)/studio/forms/existing"),
);
export const StudioFormBuilder = lazy(
  () => import("../pages/(home)/(company)/studio/forms/builder"),
);

export const HelpAndSupport = lazy(
  () => import("../pages/(home)/(company)/help-and-support"),
);
export const UpsertTicket = lazy(
  () => import("../pages/(home)/(company)/help-and-support/UpsertTicket"),
);
export const TicketsList = lazy(
  () => import("../pages/(home)/(company)/help-and-support/TicketsList"),
);
export const TicketDetailsView = lazy(
  () => import("../pages/(home)/(company)/help-and-support/TicketDetailsView"),
);
export const AnnouncementCreationForm = lazy(
  () =>
    import("../pages/(home)/(company)/announcement/_components/AnnouncementCreationForm"),
);
export const CompanyAnnouncementsManagement = lazy(
  () => import("../pages/(home)/(company)/announcement"),
);
export const CompanyAnnouncementsListPage = lazy(
  () => import("../pages/(home)/(company)/announcement/list"),
);
export const CompanyAnnouncementDetailPage = lazy(
  () => import("../pages/(home)/(company)/announcement/detail"),
);
export const CompanyNotifications = lazy(
  () => import("../pages/(home)/(company)/notifications"),
);

export const CompanyOffboarding = lazy(() => import("../pages/(home)/(company)/offboarding"));
export const CompanyOffboardingsListPage = lazy(
  () => import("../pages/(home)/(company)/offboarding/offboardings"),
);
export const CompanyOffboardingPendingApprovalsPage = lazy(
  () => import("../pages/(home)/(company)/offboarding/pending-approvals"),
);
export const CompanyOffboardingFinalSettlementsPage = lazy(
  () => import("../pages/(home)/(company)/offboarding/final-settlements"),
);
export const CompanyPayrollLayout = lazy(() =>
  import("../pages/(home)/(company)/payrolls/layout").then((m) => ({
    default: m.CompanyPayrollLayout,
  })),
);
export const CompanyOffboardingDetail = lazy(() => import("../pages/(home)/(company)/offboarding/detail"));
export const CompanyOffboardingStart = lazy(() => import("../pages/(home)/(company)/offboarding/start"));

export const MySpaceOffboarding = lazy(() => import("../pages/(home)/(my-space)/offboarding"));
// =======> E-SIGNATURE <=======
export const ESignaturePage = lazy(
  () => import("../pages/(home)/(company)/esignature"),
);

// =======> EXPENSES <=======
export const MsExpenses = lazy(
  () => import("../pages/(home)/(my-space)/expenses"),
);
export const MsDigitalId = lazy(
  () => import("../pages/(home)/(my-space)/digital-id"),
);
export const MsDigitalIdSubmissions = lazy(
  () => import("../pages/(home)/(my-space)/digital-id/submissions"),
);
export const MsMyExpensesPage = lazy(
  () => import("../pages/(home)/(my-space)/expenses/my-expenses"),
);
export const MsMyReimbursementsPage = lazy(
  () => import("../pages/(home)/(my-space)/expenses/my-reimbursements"),
);

export const CompanyExpenses = lazy(
  () => import("../pages/(home)/(company)/expenses"),
);
export const CompanyAllExpensesPage = lazy(
  () => import("../pages/(home)/(company)/expenses/all-expenses"),
);
export const CompanyProjectExpensesPage = lazy(
  () => import("../pages/(home)/(company)/expenses/project-expenses"),
);
export const CompanyAssetExpensesPage = lazy(
  () => import("../pages/(home)/(company)/expenses/asset-expenses"),
);
export const CompanyMiscExpensesPage = lazy(
  () => import("../pages/(home)/(company)/expenses/misc-expenses"),
);
export const CompanyExpenseReimbursementsPage = lazy(
  () => import("../pages/(home)/(company)/expenses/reimbursements"),
);
export const CompanyExpenseRequestsPage = lazy(
  () => import("../pages/(home)/(company)/expenses/expense-requests"),
);
export const CompanyExpenseDetail = lazy(
  () => import("../pages/(home)/(company)/expenses/expense-detail"),
);
export const CompanyProjectDetail = lazy(
  () => import("../pages/(home)/(company)/expenses/project-detail"),
);
export const MsExpenseDetail = lazy(
  () => import("../pages/(home)/(my-space)/expenses/expense-detail"),
);
export const MsExpenseCreate = lazy(
  () => import("../pages/(home)/(my-space)/expenses/create"),
);
export const MsExpenseEdit = lazy(
  () => import("../pages/(home)/(my-space)/expenses/edit"),
);
export const CompanyExpenseCreate = lazy(
  () => import("../pages/(home)/(company)/expenses/create"),
);
export const CompanyExpenseEdit = lazy(
  () => import("../pages/(home)/(company)/expenses/edit"),
);
export const CompanyReimbursementDetail = lazy(
  () => import("../pages/(home)/(company)/expenses/reimbursement-detail"),
);
export const MsReimbursementDetail = lazy(
  () => import("../pages/(home)/(my-space)/expenses/reimbursement-detail"),
);

// =======> SALES & COMMISSIONS <=======
export const MsSalesCommissions = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions"),
);
export const MsMySalesPage = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions/my-sales"),
);
export const MsMyCommissionPage = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions/my-commission"),
);
export const MsSaleCreate = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions/create"),
);
export const MsSaleEdit = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions/edit"),
);
export const MsSaleDetail = lazy(
  () => import("../pages/(home)/(my-space)/sales-commissions/sale-detail"),
);

export const CompanySalesCommissions = lazy(
  () => import("../pages/(home)/(company)/sales-commissions"),
);
export const CompanyAllSalesPage = lazy(
  () => import("../pages/(home)/(company)/sales-commissions/all-sales"),
);
export const CompanySaleRequestsPage = lazy(
  () => import("../pages/(home)/(company)/sales-commissions/sale-requests"),
);
export const CompanyCommissionsPage = lazy(
  () => import("../pages/(home)/(company)/sales-commissions/commissions"),
);
export const CompanySaleCreate = lazy(
  () => import("../pages/(home)/(company)/sales-commissions/create"),
);
export const CompanySaleDetail = lazy(
  () => import("../pages/(home)/(company)/sales-commissions/sale-detail"),
);

// =======> BIOMETRIC DEVICES <=======
export const CompanyBiometricDevices = lazy(
  () => import("../pages/(home)/(company)/biometric-devices"),
);
export const CompanyBiometricDevicesListPage = lazy(
  () => import("../pages/(home)/(company)/biometric-devices/devices"),
);
export const CompanyUnmappedEventsPage = lazy(
  () =>
    import("../pages/(home)/(company)/biometric-devices/unmapped-events"),
);
export const CompanyBiometricDevicesSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/biometric-devices/settings").then(
    (m) => ({ default: m.CompanyBiometricDevicesSettings }),
  ),
);
export const CompanyDeviceEventsPage = lazy(
  () => import("../pages/(home)/(company)/biometric-devices/device-events"),
);

// =======> CAMERAS <=======
export const CompanyCameraPage = lazy(() =>
  import("../pages/(home)/(company)/camera").then((m) => ({
    default: m.CompanyCameraPage,
  })),
);

export const CompanyCamerasListPage = lazy(
  () => import("../pages/(home)/(company)/camera/list"),
);

export const CompanyCameraRecordingPage = lazy(
  () => import("../pages/(home)/(company)/camera/detail"),
);

export const CompanyCameraSettingsPage = lazy(
  () => import("../pages/(home)/(company)/camera/settings"),
);

// =======> ADD-ONS <=======
export const CompanyAddOnsPage = lazy(() =>
  import("../pages/(home)/(company)/add-ons").then((m) => ({
    default: m.CompanyAddOnsPage,
  })),
);

// =======> TASKS <=======
export const CompanyTasks = lazy(
  () => import("../pages/(home)/(company)/tasks"),
);
export const CompanyTaskBoard = lazy(
  () => import("../pages/(home)/(company)/tasks/board"),
);
export const CompanyTaskDetail = lazy(
  () => import("../pages/(home)/(company)/tasks/task-detail"),
);
export const MsTasks = lazy(() => import("../pages/(home)/(my-space)/tasks"));
export const MsTaskBoard = lazy(
  () => import("../pages/(home)/(my-space)/tasks/board"),
);
export const MsTaskDetail = lazy(
  () => import("../pages/(home)/(my-space)/tasks/task-detail"),
);
export const MsTaskRedirect = lazy(
  () => import("../pages/(home)/(my-space)/tasks/task-redirect"),
);

// ── Data Transfer (bulk import / export) ─────────────────────────────────────
export const CompanyDataTransfer = lazy(
  () => import("../pages/(home)/(company)/data-transfer"),
);
export const CompanyDataTransferImportPage = lazy(
  () => import("../pages/(home)/(company)/data-transfer/import"),
);
export const CompanyDataTransferExportPage = lazy(
  () => import("../pages/(home)/(company)/data-transfer/export"),
);
export const CompanyDataTransferHistoryPage = lazy(
  () => import("../pages/(home)/(company)/data-transfer/history"),
);
export const CompanyDataTransferRunPage = lazy(
  () => import("../pages/(home)/(company)/data-transfer/run"),
);

// ── Integrations (Jira today, more providers later) ──────────────────────────
export const CompanyIntegrations = lazy(
  () => import("../pages/(home)/(company)/integrations"),
);

// ── Audit Logs ────────────────────────────────────────────────────────────────
export const CompanyAuditLogsPage = lazy(() =>
  import("../pages/(home)/(company)/audit-logs").then((m) => ({
    default: m.CompanyAuditLogsPage,
  })),
);
export const CompanyAuditLogsListPage = lazy(
  () => import("../pages/(home)/(company)/audit-logs/list"),
);
export const CompanyAuditLogSettingsPage = lazy(() =>
  import("../pages/(home)/(company)/audit-logs/settings").then((m) => ({
    default: m.CompanyAuditLogSettingsPage,
  })),
);
export const CompanyAuditLogDetailPage = lazy(
  () => import("../pages/(home)/(company)/audit-logs/detail"),
);
